<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content>

  <mat-card appearance="outlined">
    <mat-card-title>Details</mat-card-title>
    <div class="form-container">
      <ng-template formHost></ng-template>
    </div>
  </mat-card>

  <div class="spacer"></div>

  <div class="split-wrapper">
    <mat-card appearance="outlined" class="split">
      <ul *ngFor="let entry of legacyCompositionImportIds">
        <li>{{entry}}</li>
      </ul>
    </mat-card>
    <mat-card appearance="outlined" class="split">
      <ul *ngFor="let entry of legacyCompositionCodeSnippets">
        <li>{{entry}}</li>
      </ul>
    </mat-card>
  </div>

  <div class="spacer"></div>

  <button (click)="onSave()" color="primary" mat-button mat-raised-button>Save</button>
  <button (click)="showSnippetsTable=true; showImportTable=false" *ifPrivilege="{name: 'read', value: 'code-snippets'}" color="primary"
          mat-button
          mat-raised-button
  >Add/Remove Snippet
  </button>
  <button (click)="showImportTable=true; showSnippetsTable=false;" *ifPrivilege="{name: 'read', value: 'imports'}" color="primary"
          mat-button
          mat-raised-button
  >Add/Remove Importer
  </button>

  <div class="spacer"></div>
  <ng-container *ifPrivilege="{name: 'read', value: 'code-snippets'}">
    <mat-card appearance="outlined" *ngIf="showSnippetsTable">
      <data-table
        (custom)="onCustomCodeSnippet($event)"
        [columns]="columnsCodeSnippets"
        [dataProvider]="codeSnippetService"
        [title]="'Choose Code Snippet'"
        [validator]="{ validate:'name',  target:this.legacyCompositionCodeSnippets}"
        alternative_icon="remove_circle"
        icon="add_circle"
      ></data-table>
    </mat-card>
  </ng-container>

  <ng-container *ifPrivilege="{name: 'read', value: 'imports'}">
    <div *ngIf="showImportTable" class="split-wrapper">
      <mat-card appearance="outlined" class="split">
        <data-table
          (custom)="onCustomImportType($event)"
          [columns]="columnsImportType"
          [dataProvider]="importTypeService"
          [title]="'Filter ImportType'"
          icon="arrow_forward"></data-table>
      </mat-card>
      <mat-card appearance="outlined" class="split">
        <data-table
          (custom)="onCustomImport($event)"
          [columns]="columnsImport"
          [dataProviderParams]="paramsImport"
          [dataProvider]="importService"
          [title]="'Choose Imports'"
          [validator]="{ validate:'_id',  target:this.legacyCompositionImportIds}"
          alternative_icon="remove_circle"
          icon="add_circle"
        ></data-table>
      </mat-card>
    </div>
  </ng-container>


</page-content>
